<template>
  <el-radio-group :value="tjbForm[key]" @change.native="onChange">
    <el-radio
      v-for="item in options"
      :label="item.value"
      :key="item.value"
    >{{item.displayName}}</el-radio>
  </el-radio-group>
</template>

<script>
import storeMixins from '../store-mixins'
export default {
  mixins: [storeMixins],
  props: ['props', 'isSizeGroup'],
  data() {
    return {
      isHasOptionsComp: true,
    }
  },
  computed: {
    key() {
      return this.props.name
    },
    defaultValue() {
      return this.props.dataSource.defaultValue;
    },
  },
  methods: {
    onChange(v) {
      const newFormFields = {}
      newFormFields[this.key] = v.target.value
      this.updateTjbForm(newFormFields)
    }
  },
  updated() {
    // 处理采购地库存类型后端返回数据不在可选项的情况
    if (this.key === 'stockType' && this.tjbForm[this.key]) {
      if (!this.options.find(item => item.value === this.tjbForm[this.key])) {
        this.onChange({target: {value: ''}})
      }
    }
    // 处理库存计数后端返回数据不在可选项的情况
    if (this.key === 'subStock') {
      if (!this.options.find(item => item.value === String(this.tjbForm[this.key]))) {
        this.onChange({target: {value: '1'}})
      }
    }

    if (this.isSizeGroup) {
      if (!this.options.find(item => item.value === this.tjbForm[this.key])) {
        const commonSize = this.options.find(item => item.displayName === '通用')
        commonSize && this.onChange({target: commonSize})
      }
    }
  }
};
</script>